enum Geo {
  NA = 'NA',
  EMEA = 'EMEA',
  GC = 'GC',
  APLA = 'APLA',
}

export default Geo;
